import { render, staticRenderFns } from "./RaceNavNextToGo.vue?vue&type=template&id=21c9e438&"
import script from "./RaceNavNextToGo.vue?vue&type=script&lang=js&"
export * from "./RaceNavNextToGo.vue?vue&type=script&lang=js&"
import style0 from "./RaceNavNextToGo.vue?vue&type=style&index=0&id=21c9e438&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports